import messages from './message.js'
import labels from './label.js'

var errorHandler = {

	errorsToArray: function(errors){
    let res = []
    if(!errors.value) return res;
    Object.keys(errors.value).forEach((key) => {
      let value = errors.value[key]
      if (typeof value === 'string') {
        res.push( (labels[key] ? labels[key] : key ) + " : " + messages[value] )
      } else {
        res.push( (labels[key] ? labels[key] : key ) + " : " + value.map(e => messages[e]) )
      }
      
    })
    return res;
  }
}

export default errorHandler